import script from "./MarkDownComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarkDownComponent.vue?vue&type=script&setup=true&lang=ts"

import "./MarkDownComponent.vue?vue&type=style&index=0&id=88598226&lang=scss"

const __exports__ = script;

export default __exports__